export default "__VITE_ASSET__BPLdwtIW__"